import React, { useEffect, useRef, useState } from 'react';
import circle from '../assets/circle.png';

const RotatingCircle = () => {
  const containerRef = useRef(null);
  const circleRef = useRef(null);
  const [isInView, setIsInView] = useState(false);
  const animationId = useRef(null);
  const directionRef = useRef(1);
  const angle = useRef(0);
  const stopTimeout = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setIsInView(entry.isIntersecting),
      { threshold: 0.6 }
    );

    const container = containerRef.current;
    if (container) observer.observe(container);

    return () => {
      if (container) observer.unobserve(container);
    };
  }, []);

  const startRotation = () => {
    if (animationId.current) return;

    const rotate = () => {
      angle.current += directionRef.current * 6;
      if (circleRef.current) {
        circleRef.current.style.transform = `rotate(${angle.current}deg)`;
      }
      animationId.current = requestAnimationFrame(rotate);
    };

    animationId.current = requestAnimationFrame(rotate);
  };

  const stopRotation = () => {
    if (animationId.current) {
      cancelAnimationFrame(animationId.current);
      animationId.current = null;
    }
  };

  useEffect(() => {
    const handleWheel = (e) => {
      if (!isInView) return;

      directionRef.current = e.deltaY > 0 ? 1 : -1;
      startRotation();

      if (stopTimeout.current) clearTimeout(stopTimeout.current);

      stopTimeout.current = setTimeout(() => {
        stopRotation();
      }, 50);
    };

    window.addEventListener('wheel', handleWheel);

    return () => {
      window.removeEventListener('wheel', handleWheel);
      stopRotation();
      if (stopTimeout.current) clearTimeout(stopTimeout.current);
    };
  }, [isInView]);

  return (
    <div ref={containerRef} className="flex justify-center items-start w-full">
      <div ref={circleRef} className="hidden lg:block">
        <img
          src={circle}
          alt="Rotating Circle"
          className="w-64 h-64 select-none"
          draggable={false}
        />
      </div>
    </div>
  );
};

export default RotatingCircle;
